import React, { useContext } from "react"
import { navigate } from "gatsby"
import styled from "styled-components"

import {
  ContentfulPage,
  ContentfulHeading,
  ContentfulParagraph,
  ContentfulLink,
  ParagraphWithRemarkFragment,
} from "../../types/graphql-types"
import Link from "./link"
import Button from "./forms/button"
import Paragraph from "../components/paragraph"
import LocaleContext from "../context/localeContext"
import { createLocalizedPath } from "../utils/urlUtils"
interface Props {
  page: ContentfulPage
  center?: boolean
}

const Container = styled.div<{ center?: boolean }>`
  text-align: ${props => (props.center ? "center" : "left")};
`

export const renderLink = (link: ContentfulLink) => {
  const locale = useContext(LocaleContext)
  switch (link.type) {
    case "link":
      return <Link to={createLocalizedPath(locale, link.url!)} data-gtm-cta={link.gtm!} />
    case "button":
      return (
        <Button
          type="button"
          onClick={() => navigate(createLocalizedPath(locale, link.url!))}
          data-gtm-cta={link.gtm!}
        >
          {link.heading!}
        </Button>
      )
    default:
      return undefined
  }
}

const GenericSections = ({ page, center }: Props) => {
  const { sections } = page

  return (
    <Container center={center}>
      {sections!.map((section, index) => {
        switch (section?.internal.type) {
          case "ContentfulHeading":
            return <h2 key={index}>{(section as ContentfulHeading).heading}</h2>
          case "ContentfulParagraph":
            return <Paragraph key={index} content={section as ParagraphWithRemarkFragment} />
          case "ContentfulLink":
            return renderLink(section as ContentfulLink)
          default:
            return undefined
        }
      })}
    </Container>
  )
}

export default GenericSections
